module.exports = __webpack_public_path__ + "img/dar-image-2.a4757399.jpeg";